module.exports = __webpack_public_path__ + "img/promotions.1409354b.svg";